import type { User } from '@sentry/react';

import { ConsoleLogLevel, LogLevel } from '../constants';
import { Handler } from './types';

export default class Console implements Handler {
  user: User | null = null;

  // oxlint-disable-next-line typescript/no-explicit-any
  log(level: LogLevel, message: string, error: any, params: any[]): void {
    // oxlint-disable-next-line typescript/no-explicit-any
    const normalized: any[] = [];

    if (this.user && this.user.username) {
      normalized.push(`${this.user.username} : `);
    }
    normalized.push(message);
    if (error) {
      normalized.push(error);
    }
    if (params.length) {
      normalized.push(...params);
    }

    // @ts-ignore
    console[ConsoleLogLevel[level]](...normalized);
  }

  setUser(user: User | null): void {
    this.user = user;
  }
}
